import { render, staticRenderFns } from "./chip-tertiary.vue?vue&type=template&id=4d2b00f0&scoped=true&"
import script from "./chip-tertiary.vue?vue&type=script&lang=js&"
export * from "./chip-tertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2b00f0",
  null
  
)

export default component.exports